import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AssignedCustomer } from '../components/select-customer/model/paginated-assigned-customer.model';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UserStateService {
  private readonly userFormSubject = new BehaviorSubject<FormGroup>(null);
  userForm$ = this.userFormSubject.asObservable();

  private readonly assignedCustomersSubject = new BehaviorSubject<AssignedCustomer[]>([]);
  assignedCustomers$ = this.assignedCustomersSubject.asObservable();

  resetSelectedCustomer() {
    this.assignedCustomersSubject.next([]);
  }

  resetState() {
    this.userFormSubject.next(null);
  }

  setUserForm(userForm: FormGroup) {
    this.userFormSubject.next(userForm);
  }

  getUserForm(): FormGroup {
    return this.userFormSubject.getValue();
  }

  setAssignedCustomers(customers: AssignedCustomer[]) {
    this.assignedCustomersSubject.next(customers);
  }

  getAssignedCustomers(): AssignedCustomer[] {
    return this.assignedCustomersSubject.getValue();
  }
}
